import BaseModel from "../core/BaseModel";
export default class SuppliesEquipmentModel extends BaseModel {
  constructor() {
    super(
      {
        name: "supplies_equipment",
        tableName: "supplies_equipment",
        label: "Vật tư & thiết bị nhà thầu",
        display_key: "name",
      },
      {
        stt: { 
          name: "stt", 
          label: "STT",
          class: 'center', 
          computed: (data, index) => {
            data.stt = index + 1;
          }
        },
        id: {
          name: "id",
          type: "Uuid",
          label: "ID",
          primaryKey: true,
          display: false,
        },
        // code: {
        //   name: "code",
        //   type: "String",
        //   label: "Mã nhà thầu",
        //   filter: { type: "input", match: "contains" },
        // },
        type: {
          name: "type",
          label: "Loại",
          type: "Selection",
          custom: "SelectionText",
          // class: "center",
          options: [
            { value: 'supplies', label: "Vật tư" },
            { value: 'equipment', label: "Thiết bị" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        },
        avatar : {
          name: 'avatar', 
          type: "Image", 
          label: 'Ảnh',
        },
        name: {
          name: "name",
          type: "String",
          label: "Tên",
          filter: { type: "input", match: "contains" },
        },
        contractor_name : {
          name: 'contractor_name', 
          type: "TEXT", 
          label: 'Nhà thầu',
          filter: { type: "input", match: "contains" },
        },
        active_html: {
          name: "active_html",
          label: "Hiển thị",
          type: "Selection",
          custom: "SelectionText",
          class: "center",
          options: [
            { value: true, label: "Hiện" },
            { value: false, label: "Ẩn" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        },
        updated_by: {
          name: "updated_by",
          type: "String",
          label: "Người cập nhật"
        },

        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối"
        },

        deleted: {
          name: "deleted",
          label: "Xóa",
          type: "Checkbox",
          display: false,
        },
      }
    );
  }
}
